import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import AttestationServices from './AttestationServices';
import ExpressFlyer from './ExpressFlyer';
import RedBox from './RedBox';
import StudentExpress from './StudentExpress';


const InternationalExpress = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 50)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+200;

        (top > header_height && window_width > 1024) ? document.querySelector("nav").classNameList.add('fixed-header-desktop') : document.querySelector("nav").classNameList.remove('fixed-header-desktop')
    }, false);
  
    return(
        <div>
            <div id='international' >
                <img src='/Home/international-express.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    Our International courier and logistics operation is your strong connection for moving 
                    anything to and from Pakistan, locally and globally. Our services include regular and discounted 
                    document services, PI-2 and PI-3, Student Express—which allows flat rate for educational 
                    organisations worldwide. We also cater to full range of international non-Doc services including 
                    PN, Export Express, Import Express and the Freight Plus, whether you need to ship something personally, 
                    as a B2B or a B2C customer.
                </p>
                <p>
                    With stations and hubs in the UK, UAE and Canada, our international operations always stay on top of the 
                    changing international trends so you can receive the best international courier and logistics services, 
                    round the clock, 365 days a year.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/international-express/redbox"  className='font-bold'>RedBox</Link></li>
                            </div>
                           

                            <div className="flex items-center">
                                <li><Link to="/international-express/student-express" className='font-bold'>Students Express</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/international-express/express-flyer" className='font-bold'>Express Flyer</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/international-express/attestation-services" className='font-bold'>Attestation Services</Link></li>
                            </div>
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>

            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="redbox">
                <RedBox />
            </div>
            <div id="express-flyer">
                <ExpressFlyer />
            </div>
            <div id="student-express">
                <StudentExpress />
            </div>
            <div id="attestation-services">
                <AttestationServices />
            </div>
           </div>
        </div>
    )
};
export default InternationalExpress;